import script from "./ViewMedicineCabinet.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMedicineCabinet.vue?vue&type=script&setup=true&lang=js"

import "./ViewMedicineCabinet.vue?vue&type=style&index=0&id=649986f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649986f5"]])

export default __exports__